import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Col } from "reactstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin';
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage";



class EditCustomerDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            customerId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
            "name": "", "alternateNumber": "", "roadSize": "", "doorNumber": "", "streetName": "",
            "distanceBetweenGateAndSump": "", "area": "", "city": "Chennai", "landmark": "", "pincode": "",
            "tankCapacity": "", "dailyNeed": "","pocName1": "", "pocContactNumber1": "", "pocName2": "", "pocContactNumber2": "", "totalDissolvedSolids": "",
            oldDoorNumber: "", oldStreetName: "", oldArea: "", oldCity: "", "userFirstName": "", "userlastname": "", "userId" : "", altmsg: "", imageData: "",profileImg: '',editprofile: '',
			
        };
        this.nextPath = this.nextPath.bind(this);
        this.handleFormFields = this.handleFormFields.bind(this);
		this.handleChange = this.handleChange.bind(this);
        this.validator = new SimpleReactValidator({ messages: { currency: "Must be a valid number" }, autoForceUpdate: this, className: 'text-danger' });

    }

    nextPath(path, value) {
        this.props.history.push({ pathname: path, data: value });
    }

	handleChange = event => {
		this.setState({editprofile: event.target.files[0]}, function () { });

	}
    componentDidMount() {
		
		logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		})
        const url = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/getICbyId/" + this.state.customerId
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data => {
            //console.log(data.userdata.userLastName) 
            this.setState({
                userId: data.userdata.id, userFirstName: data.userdata.userFirstName, 
				userlastname:  data.userdata.userLastName,
                oldDoorNumber: data.individualCustomerData[0].doorNumber, oldStreetName: data.individualCustomerData[0].streetName,
                oldArea: data.individualCustomerData[0].area, oldCity: data.individualCustomerData[0].city,
                name: data.userdata.userFirstName +' '+ data.userdata.userLastName, doorNumber: data.individualCustomerData[0].doorNumber,
                streetName: data.individualCustomerData[0].streetName, area: data.individualCustomerData[0].area, city: data.individualCustomerData[0].city,
                landmark: data.individualCustomerData[0].landmark, pincode: data.individualCustomerData[0].pincode,
                roadSize: data.individualCustomerData[0].roadSize, alternateNumber: data.individualCustomerData[0].alternateNumber,
                distanceBetweenGateAndSump: data.individualCustomerData[0].distanceBetweenGateAndSump,
                tankCapacity: data.individualCustomerData[0].tankCapacity, dailyNeed: data.individualCustomerData[0].dailyNeed, totalDissolvedSolids: data.individualCustomerData[0].totalDissolvedSolids,
                pocName1: data.individualCustomerData[0].pocName1, pocContactNumber1: data.individualCustomerData[0].pocContactNumber1,
          
                pocName2: data.individualCustomerData[0].pocName2, pocContactNumber2: data.individualCustomerData[0].pocContactNumber2, imageData: data.individualCustomerData[0].profileimageurl
            })
        }).catch(error => console.log(error))
    }

    save = () => {
        if (this.validator.allValid() && this.state.altmsg != 1) {
			
			
			if(this.state.editprofile != "")
			{
		
				var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editprofile.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.editprofile).then(snapshot => {
					console.log(snapshot)
				const postCustData = {

					"name": this.state.name,"userFirstName": this.state.userFirstName, "userLastName" : this.state.userlastname,
					"doorNumber": this.state.doorNumber,
					"streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
					"landmark": this.state.landmark,
					"pincode": this.state.pincode, roadSize: this.state.roadSize,
					"alternateNumber": this.state.alternateNumber, 
					"distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
					"tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
					"pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
					"pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
					id: this.state.customerId, "uid" : this.state.userId,"imageurl": snapshot.metadata.downloadURLs[0]
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/indiv-customer/updateCustomer', {
					method: 'PUT',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					body: JSON.stringify(postCustData)
				}).then(response => response.json())
					.then(data => {
						// if (this.state.oldDoorNumber !== this.state.doorNumber ||
							// this.state.oldStreetName !== this.state.streetName ||
							// this.state.oldArea !== this.state.area ||
							// this.state.oldCity !== this.state.city) {
							// this.createNewDriveryAddress(data.individualId);
						// } else {
							this.nextPath("/indiv-customer/customer-details", this.state.customerId)
							toast.success("Profile updated successfully!!!", {
								position: toast.POSITION.TOP_CENTER,

							});
						// }
					})
					.catch((err) => console.log(err))
					
				})
			}
			else {
				const postCustData = {

					"name": this.state.name,"userFirstName": this.state.userFirstName, "userLastName" : this.state.userlastname,
					"doorNumber": this.state.doorNumber,
					"streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
					"landmark": this.state.landmark,
					"pincode": this.state.pincode, roadSize: this.state.roadSize,
					"alternateNumber": this.state.alternateNumber, 
					"distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
					"tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
					"pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
					"pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
					id: this.state.customerId, "uid" : this.state.userId
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/indiv-customer/updateCustomer', {
					method: 'PUT',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					body: JSON.stringify(postCustData)
				}).then(response => response.json())
					.then(data => {
						// if (this.state.oldDoorNumber !== this.state.doorNumber ||
							// this.state.oldStreetName !== this.state.streetName ||
							// this.state.oldArea !== this.state.area ||
							// this.state.oldCity !== this.state.city) {
							// this.createNewDriveryAddress(data.individualId);
						// } else {
							this.nextPath("/indiv-customer/customer-details", this.state.customerId)
							toast.success("Profile updated successfully!!!", {
								position: toast.POSITION.TOP_CENTER,

							});
						// }
					})
					.catch((err) => console.log(err))
				
			}
				
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    createNewDriveryAddress = (individualId) => {
        fetch(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
            "&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
        ).then(data => data.json())
            .then(resp => {
                const { lat, lng } = resp.results[0].geometry.location;
                this.createAddress(individualId, lat, lng)
                this.setState({ lat: lat, lng: lng })
            })
            .catch(err => console.log(err));
    }

    createAddress = (individualId, lattitude, longitude) => {
        let postAddressData = {
            associateId: individualId, defaultAddress: "No",
            fullAddress: this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city, geolocationLat: lattitude, geolocationLng: longitude, label: "Billing Address"
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
            body: JSON.stringify(postAddressData)
        }).then((response) => response.json())
            .then(data => {
                this.nextPath("/indiv-customer/customer-details", this.state.customerId)
            })
    }

    handleFormFields = (event) => {
        this.validator.showMessageFor(event.target.name)
        switch (event.target.id) {
           
            
            case "ufname":
                this.setState({ "userFirstName": event.target.value });
                break;

            case "ulname":
                this.setState({ "userlastname": event.target.value });
                break;

            case "alternateNumber":
                this.setState({ "alternateNumber": event.target.value });
				this.alternatenumber(event.target.value)
                break;

            case "udoorNumber":
                this.setState({ "doorNumber": event.target.value });
                break;
            case "ustreetName":
                this.setState({ "streetName": event.target.value });
                break;
            case "uarea":
                this.setState({ "area": event.target.value });
                break;
            case "ucity":
                this.setState({ "city": event.target.value });
                break;
            case "ulandmark":
                this.setState({ "landmark": event.target.value });
                break;
            case "upincode":
                this.setState({ "pincode": event.target.value });
                break;
            case "uroadSize":
                this.setState({ "roadSize": event.target.value });
                break;
            case "udistanceBetweenGateAndSump":
                this.setState({ "distanceBetweenGateAndSump": event.target.value });
                break;
            case "utankCapacity":
                this.setState({ "tankCapacity": event.target.value });
                break;
            case "udailyNeed":
                this.setState({ "dailyNeed": event.target.value });
                break;
            case "utotalDissolvedSolids":
                this.setState({ "totalDissolvedSolids": event.target.value });
                break;
           /* case "upocName1":
                this.setState({ "pocName1": event.target.value });
                break;
            case "upocContactnumber1":
                this.setState({ "pocContactNumber1": event.target.value });
                break;
            case "upocName2":
                this.setState({ "pocName2": event.target.value });
                break;
            case "upocContactnumber2":
                this.setState({ "pocContactNumber2": event.target.value });
                break;        */          
            default:
                break;
        }
    }
	
	 alternatenumber = (data) => 
	  {
		  if(data != "") {
			  if(data.length === 10) {
			  const postCustData = {  "alternatenumber" : data }
			  
			  
			  fetch(process.env.REACT_APP_NODE_ENV + '/api/individualcustomer/alternatenumbervalid', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ altmsg: '1'})
					}
					else {
							this.setState({ altmsg: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			  }
			   else if(data.length <= 9) {
				this.setState({ altmsg: 0 })
			}
			else if(data.length >= 11) {
				this.setState({ altmsg: 0 })
			}
				  
				  
		  }
		  else {
			  this.setState({ altmsg: '0' })
		  }
		  
		  
		  
	  }

    navigate = () => {
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE') {
            this.nextPath("/indiv-customer/customer-details", this.state.customerId)
        } else {
            this.nextPath("/")
        }
    }

    render() {

        let breadCrumbForUser = ""
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE') {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item
                    onClick={() => this.nextPath("/indiv-customer/customer-list")}
                >
                    Customer List
      </Breadcrumb.Item>

                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        } else {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        }

        return (<>
            {breadCrumbForUser}

            <div>
                <Card>
                    <Card.Body>
                        <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
							<div className="row">
								<div className="col-lg-8">
									 Customer Details - {this.state.name}
								
								</div>
								<div className="col-lg-4">
									 <Button className="float-right"
                                variant="outline-danger"
                                style={{ marginLeft: "10px", marginTop: "25px", width: "120px" }}
                                onClick={this.navigate}>
                                Cancel
                  </Button>&nbsp;&nbsp;&nbsp;
                            <Button className="float-right"
                                variant="outline-success"
                                style={{ marginTop: "25px", width: "120px" }}
                                onClick={this.save}>
                                Save
                  </Button>
									
								</div>
							</div>
                           
                           
                        </Card.Title>
                        <br />
                        <br />
                        <Tabs defaultActiveKey="basic-details">
                            <Tab eventKey="basic-details" title="Basic Details">
                                <Form>
									<div className="kt-heading kt-heading--md">Basic Details </div>
                                    <Form.Row>
									  <Form.Group controlId="ufname" as={Col} className="col-lg-3">
                                            <Form.Label>First Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="userFirstName"

                                                value={this.state.userFirstName}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                            {
                                                this.validator.message('First Name', this.state.userFirstName,
                                                    'required|alpha_num_space|max:50')
                                            }
                                        </Form.Group>
                                        <Form.Group controlId="ulname" as={Col} className="col-lg-3">
                                            <Form.Label>Last Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="userLastName"

                                                value={this.state.userlastname}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                            {
                                                this.validator.message('Last Name', this.state.userlastname,
                                                    'required|alpha_num_space|max:50')
                                            }
                                        </Form.Group>
										<Form.Group controlId="ulname" as={Col} className="col-lg-3">
                                            <Form.Label>Profile Image: *</Form.Label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.handleChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
                                        </Form.Group>
                                        <div className="col-lg-2" style={{ margin:"20px 0px" }}>
										  <img src={this.state.imageData}  width="80px" height = "40px"  />
										</div>

                                      
                                    </Form.Row>
									<div className="kt-heading kt-heading--md">Billing Address </div>
                                    <Form.Row>
									  
									   
                                        <Form.Group as={Col} controlId="udoorNumber" className="col-lg-4">
                                            <Form.Label> Door Number: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.doorNumber}
                                                onChange={this.handleFormFields}
                                                name="doorNumber"
                                            ></Form.Control>
                                            {
                                                this.validator.message('Door Number', this.state.doorNumber,
                                                    'required')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ustreetName" className="col-lg-4">
                                            <Form.Label> Street Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.streetName}
                                                onChange={this.handleFormFields}
                                                name="streetName"
                                            ></Form.Control>
                                            {
                                                this.validator.message('Street Name', this.state.streetName,
                                                    'required')
                                            }
                                        </Form.Group>
										<Form.Group as={Col} controlId="uarea" className="col-lg-4">
                                            <Form.Label> Area: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.area}
                                                name="area"
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('Area', this.state.area,
                                                    'required|regex:^[a-zA-Z-. ]*$')
                                            }
                                        </Form.Group>
                                      
                                    </Form.Row>

                                    <Form.Row>
									     
                                        <Form.Group as={Col} controlId="ucity">
                                            <Form.Label> City: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.city}
                                                onChange={this.handleFormFields}
                                                name="city"
                                            >
                                                <option value="">Select Your City</option>
                                                <option value="Chennai">Chennai</option>
                                            </Form.Control>
                                            {
                                                this.validator.message('city', this.state.city,
                                                    'required|alpha_space')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ulandmark">
                                            <Form.Label> Landmark: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.landmark}
                                                onChange={this.handleFormFields}
                                                name="landmark"
                                            ></Form.Control>
                                            {
                                                this.validator.message('landmark', this.state.landmark,
                                                    'alpha_space')
                                            }
                                        </Form.Group>
										<Form.Group as={Col} controlId="upincode">
                                            <Form.Label> Pincode: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pincode}
                                                name="pincode"
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('pincode', this.state.pincode,
                                                    'required|integer|max:999999,num')
                                            }
                                        </Form.Group>
                                       
                                    </Form.Row>
									<Form.Row>
									    <Form.Group as={Col} controlId="alternateNumber" className="col-lg-4">
                                            <Form.Label>Alternate Phone Number :</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="Alternate Number"
                                                value={this.state.alternateNumber}
                                                onChange={this.handleFormFields}

                                            ></Form.Control>
											{(this.state.altmsg != 0 ?
						  <div class="text-danger">Alternate Number Already exists.</div> :  this.validator.message('Alternate Number', this.state.alternateNumber,
						'phone|max:10') )}
											
                                        </Form.Group>
									 
									</Form.Row>
                                </Form>
                            </Tab>
							{ /*     <Tab eventKey="poc" title="POC">
                                <Form>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocName1">
                                            <Form.Label> Contact Person 1:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocName1}
                                                onChange={this.handleFormFields}
                                                name="Name1"
                                            ></Form.Control>
                                            {
                                                this.validator.message('Name1', this.state.pocName1, 'required|alpha_space')
                                            }
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocContactnumber1">
                                            <Form.Label> Contact Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocContactNumber1}
                                                onChange={this.handleFormFields}
                                                name="pocContactNumber1"
                                            ></Form.Control>
                                            {
                                                this.validator.message('pocContactNumber1', this.state.pocContactNumber1, 'required|phone|max:14')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocName2">
                                            <Form.Label> Contact Person 2:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocName2}
                                                onChange={this.handleFormFields}
                                                name="Name2"
                                            ></Form.Control>
                                            
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocContactnumber2">
                                            <Form.Label>Contact Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocContactNumber2}
                                                onChange={this.handleFormFields}
                                                name="pocContactNumber2"
                                            ></Form.Control>
                                           
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>     */}
                
                            <Tab eventKey="IndividualDetails" title="Building Details">
                                <Form>
								   <div className="kt-heading kt-heading--md">Building Details </div>
                                    <Form.Row>

                                        <Form.Group as={Col} className="col-lg-4" controlId="utankCapacity">
                                            <Form.Label> Sump/Tank Capacity (in kl): *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.tankCapacity}
                                                onChange={this.handleFormFields}
                                                name="tankCapacity"
                                            ></Form.Control>
                                            {
                                                this.validator.message('Sump/Tank Capacity', this.state.tankCapacity,
                                                    'required|currency', { messages: { in: 'Sump/Tank Capacity should be a valid number!' } })
                                            }

                                        </Form.Group>
                        
                                        <Form.Group as={Col}  controlId="uroadSize" className="col-lg-4">
                                            <Form.Label>Road Size (in ft):</Form.Label>
												
                                            <Form.Control
                                                type="text"
                                                value={this.state.roadSize}
                                                onChange={this.handleFormFields}
                                                name="roadSize"
                                            ></Form.Control>
                                            {
                                                this.validator.message('roadSize', this.state.roadSize,
                                                    'integer,num')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="udistanceBetweenGateAndSump" className="col-lg-4">
                                            <Form.Label>Distance Between Gate & Sump (in ft):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="distanceBetweenGateAndSump"
                                                id="udistanceBetweenGateAndSump"
                                                value={this.state.distanceBetweenGateAndSump}
                                                onChange={this.handleFormFields}

                                            ></Form.Control>
                                            {
                                                this.validator.message('distanceBetweenGateAndSump', this.state.distanceBetweenGateAndSump,
                                                    'integer')
                                            }
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="utotalDissolvedSolids">
                                            <Form.Label>Preferred TDS: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.totalDissolvedSolids}
                                                onChange={this.handleFormFields}
                                                name="Total Dissolved Solids"
                                            >
                                                <option value="">Select TDS</option>
                                                <option value="less than 300(Excellent)"> less than 300(Excellent) </option>
                                                <option value="300-500(Good)"> 300-500(Good) </option>
                                                <option value="600-900(Fair)"> 600-900(Fair) </option>
                                                <option value="900-1200(Poor)"> 900-1200(Poor)</option>
                                                <option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable)   </option>
                                            </Form.Control>
                                            {
												this.validator.message('Preferred tds', this.state.totalDissolvedSolids, 'required|string')
                                                
                                            }
                                        </Form.Group>
                                    </Form.Row>

                                </Form>
                            </Tab>
                            
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
        );
    }
}

const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id,
		mobiledevice: state.auth.user[0].mobiledeviceId,
    }
}

export default connect(
    mapStateToProps,
    null
)(EditCustomerDetails)